import type { HTMLAttributes } from "react";

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  as?: "div" | "section" | "article" | "main";
  wide?: boolean;
};

/**
 * Responsive max-width gutter container. Defaults to the standard 1280px
 * frame; set `wide` to opt into the 1536px frame used for hero / showcase
 * layouts. All gutters consume spacing tokens via Tailwind utilities.
 */
export function Container({
  as = "div",
  wide = false,
  className = "",
  children,
  ...rest
}: ContainerProps) {
  const Tag = as;
  const max = wide ? "max-w-[1536px]" : "max-w-7xl";
  return (
    <Tag
      className={`${max} mx-auto w-full px-6 md:px-8 lg:px-10 ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
}
